(function () {
  angular.module("akitabox.ui.dialogs.message.edit", [
    "akitabox.core.services.note",
    "akitabox.core.toast",
    "ngMaterial",
  ]);
})();
